import React from "react";
import { t } from "ttag";
import { Button, Spinner, Typography } from "@coolremote/shared";
import styles from "./ListStatePanel.module.css";

interface IListStatePanelProps {
  loading?: boolean;
  empty?: boolean;
  emptyTitle: React.ReactNode;
  emptyText?: string;
  emptyIcon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionWidth?: number;
  children: React.ReactNode;
}

export const ListStatePanel: React.FC<IListStatePanelProps> = ({
  loading,
  empty,
  emptyTitle,
  emptyText,
  emptyIcon,
  actionLabel,
  onAction,
  actionWidth = 240,
  children,
}) => {
  if (loading) {
    return (
      <div className={styles.loaderWrap}>
        <Spinner size={32} />
      </div>
    );
  }

  if (empty) {
    return (
      <div className={emptyIcon ? styles.emptyStateWithIcon : styles.emptyState}>
        {emptyIcon}
        <Typography variant="cardTitle">{emptyTitle}</Typography>
        {emptyText ? (
          <Typography variant="meta" className={styles.emptyText}>
            {emptyText}
          </Typography>
        ) : null}
        {actionLabel && onAction ? (
          <Button width={actionWidth} onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </div>
    );
  }

  return <>{children}</>;
};

export default ListStatePanel;
